// import React, { useState, useEffect, KeyboardEvent } from "react";
// import "./BOQAddDetails.css";
// import axios from "axios";
// import API_URL from "../../../src/Config";
// import Tooltip from "@mui/material/Tooltip";
// import { IoMdArrowBack } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import Pagination from "../../Component/Pagination";

// function BOQAddQtyForWeek({ isSidebarExpanded }) {
//   const [boqDetail, setBoqDetail] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [boqData, setBoqData] = useState([]); // Store API data
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [totalItems, setTotalItems] = useState(0);
//   const [boqTotals, setBoqTotals] = useState(null);

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       // Fetch BOQ details
//       const boqResponse = await axios.get(`${API_URL}/api/get_amc_boqs`, {
//         headers: { Authorization: authKey },
//         params: { project_id: id },
//       });

//       setBoqDetail(boqResponse.data.BOQs);
//       setBoqTotals(boqResponse.data.totals); // ✅ ADD THIS

//       setTotalItems(boqResponse.data.TotalItems);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setError(error.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchBOQQuantity = async () => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       // Fetch BOQ quantities using the boq_id in the URL
//       const boqQtyResponse = await axios.get(
//         `${API_URL}/api/get_amc_boqs_with_quantities/${id}`,
//         {
//           headers: { Authorization: authKey },
//         },
//       );

//       // Handle the response (e.g., update state with fetched data)
//       console.log(boqQtyResponse.data.BOQs); // Use response data here
//       setBoqData(boqQtyResponse.data.BOQs || []);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setError(error.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBOQQuantity();
//   }, []);

//   const handleBack = () => {
//     navigate("/amc-projects");
//   };

//   function formatNumber(number) {
//     const parts = number.toString().split(".");
//     const integerPart = parts[0];
//     const decimalPart = parts.length > 1 ? "." + parts[1] : "";

//     let formattedIntegerPart = "";
//     let lakhFlag = false;
//     let croreFlag = false;
//     let croreLakhFlag = false;

//     for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
//       if (count === 3 && !lakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         lakhFlag = true;
//       }

//       if (count === 2 && lakhFlag && !croreFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreFlag = true;
//       }

//       if (count === 2 && croreFlag && !croreLakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreLakhFlag = true;
//       }

//       formattedIntegerPart = integerPart[i] + formattedIntegerPart;
//     }

//     return formattedIntegerPart + decimalPart;
//   }

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-edit-form-content">
//           <div className="data-edit-form-header">
//             <div className="data-edit-form-header-content">
//               <div className="data-edit-form-heading-content-left-side">
//                 <Tooltip title="Back" arrow>
//                   <IoMdArrowBack
//                     className="back-company"
//                     onClick={handleBack}
//                   />
//                 </Tooltip>
//                 BOQ Reports
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="header-separator"></div>

//         <div className="data-list-body">
//           <div className="data-list-scroll-body">
//             <div className="data-list-table">
//               {loading ? (
//                 <div className="loader-container">
//                   <div className="loader"></div>
//                   <div>Loading...</div>
//                 </div>
//               ) : boqDetail.length > 0 ? (
//                 <table className="table multilevel-data">
//                   <thead>
//                     <tr>
//                       <th rowSpan="2">Service Code</th>
//                       <th rowSpan="2">Description</th>
//                       <th rowSpan="2">UOM</th>
//                       <th rowSpan="2">Quantity</th>
//                       <th rowSpan="2">Unit Rate</th>
//                       <th rowSpan="2">Total Amount Including GST</th>

//                       <th rowSpan="2">Total Completed Qty</th>
//                       <th rowSpan="2">Balance Qty</th>
//                       <th rowSpan="2">Cummulative Amount</th>
//                       <th rowSpan="2">Balance Amount</th>
//                     </tr>
//                   </thead>
//                   <tbody className="data-list-scroll-bodys">
//                     {boqDetail.map((row, index) => {
//                       // Find matching BOQ item from boqData
//                       const matchingBoq =
//                         boqData.find((boq) => boq.id === row.id) || {};

//                       return (
//                         <tr key={index} className="hoverable-row">
//                           {/* First API: BOQ Details */}
//                           <td>{row.service_code}</td>
//                           <td>{row.description}</td>
//                           <td>{row.uom}</td>
//                           <td>{row.qty}</td>
//                           <td>₹ {formatNumber(row.unit_rate)}</td>
//                           <td>₹ {formatNumber(row.total_amount_with_gst)}</td>

//                           {/* Second API: BOQ Quantities */}
//                           <td>
//                             {formatNumber(
//                               matchingBoq.total_complete_qty ?? "-",
//                             )}
//                           </td>
//                           <td>
//                             {formatNumber(matchingBoq.balance_qty ?? "-")}
//                           </td>
//                           <td>
//                             ₹{" "}
//                             {formatNumber(matchingBoq.cumulative_amount ?? "-")}
//                           </td>
//                           <td>
//                             ₹ {formatNumber(matchingBoq.balance_amount ?? "-")}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               ) : (
//                 <div className="no-users-container">
//                   <div className="no-users-message">No BOQ Reports Found</div>
//                 </div>
//               )}
//             </div>
//           </div>
//           {/* BOQ TOTALS */}
//           {boqTotals && (
//             <div className="new_boq_totals_container">
//               <div className="new_boq_totals_row">
//                 <div className="new_boq_totals_label">Grand Total</div>

//                 <div className="new_boq_totals_item">
//                   <span className="new_boq_totals_title">Total Quantity</span>
//                   <span className="new_boq_totals_value">
//                     {formatNumber(boqTotals.total_qty)}
//                   </span>
//                 </div>

//                 <div className="new_boq_totals_item">
//                   <span className="new_boq_totals_title">Total Amount</span>
//                   <span className="new_boq_totals_value">
//                     ₹ {formatNumber(boqTotals.total_amount)}
//                   </span>
//                 </div>

//                 <div className="new_boq_totals_item highlight">
//                   <span className="new_boq_totals_title">
//                     Total Amount (Incl. GST)
//                   </span>
//                   <span className="new_boq_totals_value">
//                     ₹ {formatNumber(boqTotals.total_amount_with_gst)}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000} // Converted to milliseconds
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default BOQAddQtyForWeek;


import React, { useState, useEffect, KeyboardEvent } from "react";
import "./BOQAddDetails.css";
import axios from "axios";
import API_URL from "../../../src/Config";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Pagination from "../../Component/Pagination";

function BOQAddQtyForWeek({ isSidebarExpanded }) {
  const [boqDetail, setBoqDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [boqData, setBoqData] = useState([]); // Store API data
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [boqTotals, setBoqTotals] = useState(null);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      // Fetch BOQ details
      const boqResponse = await axios.get(`${API_URL}/api/get_amc_boqs`, {
        headers: { Authorization: authKey },
        params: { project_id: id },
      });

      setBoqDetail(boqResponse.data.BOQs);
      setBoqTotals(boqResponse.data.totals);

      setTotalItems(boqResponse.data.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setError(error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchBOQQuantity = async () => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      // Fetch BOQ quantities using the boq_id in the URL
      const boqQtyResponse = await axios.get(
        `${API_URL}/api/get_amc_boqs_with_quantities/${id}`,
        {
          headers: { Authorization: authKey },
        },
      );

      // Handle the response (e.g., update state with fetched data)
      console.log(boqQtyResponse.data.BOQs); // Use response data here
      setBoqData(boqQtyResponse.data.BOQs || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setError(error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBOQQuantity();
  }, []);

  const handleBack = () => {
    navigate("/amc-projects");
  };

  function formatNumber(number) {
    const parts = number.toString().split(".");
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? "." + parts[1] : "";

    let formattedIntegerPart = "";
    let lakhFlag = false;
    let croreFlag = false;
    let croreLakhFlag = false;

    for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
      if (count === 3 && !lakhFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        lakhFlag = true;
      }

      if (count === 2 && lakhFlag && !croreFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        croreFlag = true;
      }

      if (count === 2 && croreFlag && !croreLakhFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        croreLakhFlag = true;
      }

      formattedIntegerPart = integerPart[i] + formattedIntegerPart;
    }

    return formattedIntegerPart + decimalPart;
  }

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content">
          <div className="data-edit-form-header">
            <div className="data-edit-form-header-content">
              <div className="data-edit-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBack}
                  />
                </Tooltip>
                BOQ Reports
              </div>
            </div>
          </div>
        </div>
        <div className="header-separator"></div>

        <div className="data-list-body" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 200px)' }}>
          <div className="data-list-scroll-body" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
            <div className="data-list-table data_list_table_boq_report">
              {loading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                  <div>Loading...</div>
                </div>
              ) : boqDetail.length > 0 ? (
                <table className="table multilevel-data">
                  <thead>
                    <tr>
                      <th rowSpan="2">Service Code</th>
                      <th rowSpan="2">Description</th>
                      <th rowSpan="2">UOM</th>
                      <th rowSpan="2">Quantity</th>
                      <th rowSpan="2">Unit Rate</th>
                      <th rowSpan="2">Total Amount Including GST</th>

                      <th rowSpan="2">Total Completed Qty</th>
                      <th rowSpan="2">Balance Qty</th>
                      <th rowSpan="2">Cummulative Amount</th>
                      <th rowSpan="2">Balance Amount</th>
                    </tr>
                  </thead>
                  <tbody className="data-list-scroll-bodys">
                    {boqDetail.map((row, index) => {
                      // Find matching BOQ item from boqData
                      const matchingBoq =
                        boqData.find((boq) => boq.id === row.id) || {};

                      return (
                        <tr key={index} className="hoverable-row">
                          {/* First API: BOQ Details */}
                          <td>{row.service_code}</td>
                          <td>{row.description}</td>
                          <td>{row.uom}</td>
                          <td>{row.qty}</td>
                          <td>₹ {formatNumber(row.unit_rate)}</td>
                          <td>₹ {formatNumber(row.total_amount_with_gst)}</td>

                          {/* Second API: BOQ Quantities */}
                          <td>
                            {formatNumber(
                              matchingBoq.total_complete_qty ?? "-",
                            )}
                          </td>
                          <td>
                            {formatNumber(matchingBoq.balance_qty ?? "-")}
                          </td>
                          <td>
                            ₹{" "}
                            {formatNumber(matchingBoq.cumulative_amount ?? "-")}
                          </td>
                          <td>
                            ₹ {formatNumber(matchingBoq.balance_amount ?? "-")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="no-users-container">
                  <div className="no-users-message">No BOQ Reports Found</div>
                </div>
              )}
            </div>
          </div>
          
          {/* BOQ TOTALS - Fixed at bottom */}
          {/* {boqTotals && (
            <div className="new_boq_totals_container">
              <div className="new_boq_totals_row">
                <div className="new_boq_totals_label">Grand Total</div>

                <div className="new_boq_totals_item">
                  <span className="new_boq_totals_title">Total Quantity</span>
                  <span className="new_boq_totals_value">
                    {formatNumber(boqTotals.total_qty)}
                  </span>
                </div>

                <div className="new_boq_totals_item">
                  <span className="new_boq_totals_title">Total Amount</span>
                  <span className="new_boq_totals_value">
                    ₹ {formatNumber(boqTotals.total_amount)}
                  </span>
                </div>

                <div className="new_boq_totals_item highlight">
                  <span className="new_boq_totals_title">
                    Total Amount (Incl. GST)
                  </span>
                  <span className="new_boq_totals_value">
                    ₹ {formatNumber(boqTotals.total_amount_with_gst)}
                  </span>
                </div>
              </div>
            </div>
          )} */}

          {boqTotals && (
  <div className="new_boq_totals_container">
    <div className="new_boq_totals_row">

      <div className="new_boq_totals_card">
        <span className="new_boq_totals_title">Total Quantity</span>
        <span className="new_boq_totals_value">
          {formatNumber(boqTotals.total_qty)}
        </span>
      </div>

      <div className="new_boq_totals_card">
        <span className="new_boq_totals_title">Total Amount</span>
        <span className="new_boq_totals_value">
          ₹ {formatNumber(boqTotals.total_amount)}
        </span>
      </div>

      <div className="new_boq_totals_card gst">
        <span className="new_boq_totals_title">
          Total Amount (Incl. GST)
        </span>
        <span className="new_boq_totals_value">
          ₹ {formatNumber(boqTotals.total_amount_with_gst)}
        </span>
      </div>

    </div>
  </div>
)}

        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000} // Converted to milliseconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default BOQAddQtyForWeek;